import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "various-arrow-right",
  "use": "various-arrow-right-usage",
  "viewBox": "0 0 38 14",
  "content": "<symbol viewBox=\"0 0 38 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"various-arrow-right\"><path d=\"M24 8H0V6h24V0l14 7-14 7V8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol